<template>
  <div
    class="
      component-wrapper
      d-flex
      flex-column
      align-center
      justify-space-between
    "
  >
    <div
      class="d-flex flex-column pa-sm-12 pa-6 align-center rounded elevation-12"
    >
      <div class="mb-3">
        <img src="../assets/logotitle.png" alt="logo" class="logo" />
      </div>

      <div class="secondary--text text-center mb-8 form-title">
        ΥΠΟΒΟΛΗ ΣΥΝΑΛΛΑΓΩΝ ΕΣΩΤΕΡΙΚΟΠΟΙΗΜΕΝΟΥ ΔΙΑΚΑΝΟΝΙΣΜΟΥ
      </div>
      <v-card color="primary" class="mb-2 pa-4 text-center" max-width="400px">
        <div class="text-sm-body-1 white--text">
          Πληκτρολόγηστε τη διεύθυνση email που χρησιμοποιείτε για να
          συνδεθείτε. Θα σας στείλουμε με email έναν σύνδεσμο για να αλλάξετε
          τον κωδικό πρόσβασης.
        </div>
      </v-card>
      <v-form
        @submit.prevent="onSubmit"
        class="d-flex flex-column justify-center form"
      >
        <v-text-field
          v-model="email"
          label="Email"
          color="primary"
          prepend-inner-icon="mdi-email"
          class="mb-sm-2 mb-0"
          :error-messages="emailErrors"
        ></v-text-field>

        <v-btn type="submit" class="primary py-sm-6 py-3" :loading="loader"
          >Υποβολή</v-btn
        >
        <v-btn
          @click="$router.push('/login')"
          text
          plain
          small
          class="mt-2 ml-auto pa-0 secondary--text"
          ><div class="d-flex align-center">
            <v-icon>mdi-arrow-left</v-icon>Επιστροφή
          </div>
        </v-btn>
      </v-form>
    </div>

    <Alert v-if="showAlert" :items="alertItems" class="mt-auto"></Alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Alert from "@/components/Alert.vue";
import { required, email } from "vuelidate/lib/validators";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      alertItems: {
        strong_text: "Σφάλμα! ",
        text: " Το e-mail που πληκτρολογήσατε δεν υπάρχει.",
        text_color: "error",
        dismissable: true,
      },
      email: "",
      showAlert: false,
      loader: false,
    };
  },

  validations: {
    email: {
      required,
      email,
    },
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Το email δεν είναι έγκυρο");

      return errors;
    },
  },

  methods: {
    ...mapActions(["requestResetPassword"]),

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;
        await this.requestResetPassword({
          userEmail: this.email,
        });
        this.loader = false;
        this.$router.push("/login");
      } catch (e) {
        this.loader = false;
        this.showAlert = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 400px;
  &-title {
    font-size: 20px;
    font-weight: 600;
  }
}

.logo {
  max-width: 100%;
}

.svg {
  width: 175px;
}

@media only screen and (max-width: 960px) {
  // .logo {
  //   width: 700px;
  // }
}

@media only screen and (max-width: 600px) {
  .form {
    width: 100%;
    &-title {
      font-size: 20px;
    }
  }
  .logo {
    width: 100%;
  }
  .svg {
    width: 133px;
  }
}

@media only screen and (max-width: 450px) {
  .form {
    &-title {
      font-size: 18px;
    }
  }
}
</style>